import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../api-endpoints-constants';
import { IApiBaseObject } from '../../iModels/api-base-object.model';
import { IApiService } from '../../iservices/iApi';
import { ModelBindingService } from '../binding.model.service';
import { map } from 'rxjs/operators';
import { ModelDecoderBindingService } from '../bindingDecoder.model.service';
import { BehaviorSubject } from 'rxjs';
import { IDepartmentService } from '../../iservices/iMasterServices/iDepartment';
import { MatDialog } from '@angular/material/dialog';
import { AddDepartmentComponent } from '../../component/master/masterComponents/department/add-department/add-department.component';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService implements IDepartmentService {
  private apiObject: IApiBaseObject;
  dataHasBeenDeleted = new BehaviorSubject(false);
  tableUpdated = new BehaviorSubject(false);
  constructor( @Inject('IApiService') private apiService: IApiService,
    private modelBindingService: ModelBindingService,
    private modelDecoderBindingService: ModelDecoderBindingService,
    public dialog: MatDialog) {

  }
  /*
    * @method getDepartmentDetails()
    * @desc used to get Department list .
    * @return json array data.
  */
  getDepartmentDetails(apiGetParameters): any {
    let json;
    apiGetParameters.page = apiGetParameters.page ? apiGetParameters.page : 1;
    apiGetParameters.size = apiGetParameters.size === 0 || apiGetParameters.size ? apiGetParameters.size : 10;
    // console.log(apiGetParameters);
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.DEPARTMENT_Get_ALL, apiGetParameters);
    // console.log(url);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    // console.log(this.apiObject);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp) => {
        if (resp) {
          resp['data'] = this.modelDecoderBindingService
            .mappingDataReturn('departmentDecoder', resp);
          if (resp['data'].data) {
            json = { data: resp['data'].data, 'itemCount': resp['data'].data[0].totalRows };
          } else {
            json = { data: resp['data'].data, 'itemCount': 0 };
          }
          return json;
        }
      }
      ));
  }
  /*
    * @method addDepartment()
    * @desc used to add Department Type.
    * @param permData :array - Department data.
    * @return json array data.
  */
  addDepartment(permData): any {
    const requestData = this.modelBindingService.departmentEncoder(permData);
    this.apiObject = this.modelBindingService.setApiCallObject(API_ENDPOINTS.DEPARTMENT_ADD, requestData,
      true, false);
    return this.apiService.postApi(this.apiObject).pipe(
      map((res) => {
        return res;
      },
        (error) => {
          return error;
        }
      ));
  }

  /*
    * @method getDepartmentDetailsById()
    * @desc used to get department details by id.
    * @param id :string - department id.
    * @return json array data.
  */
  getDepartmentDetailsById(id): any {
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.DEPARTMENT_by_id, {
        id: id
      });
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp) => {
        if (resp) {
          resp['data'] = this.modelDecoderBindingService.departmentDecoder(resp['data'][0]);
          return resp;
        }
      }));
  }
  /*
   * @method delete()
   * @desc used to department row data.
   * @param id :array - department id .
   * @param id :dialogType - dialogType .
   * @return string.
  */
  delete(id): string {
    const url = this.modelBindingService.replaceUrlForDelete(
      API_ENDPOINTS.DEPARTMENT_DELETE, id);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.deleteApi(this.apiObject).pipe(
      map((response) => {
        return response;
      },
        (error) => {
          return error;
        }));
  }
}


